import { render, staticRenderFns } from "./CardAddress.vue?vue&type=template&id=16f783b6&scoped=true&"
import script from "./CardAddress.vue?vue&type=script&lang=js&"
export * from "./CardAddress.vue?vue&type=script&lang=js&"
import style0 from "./CardAddress.vue?vue&type=style&index=0&id=16f783b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f783b6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CheckoutAddressFrom: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/Checkout/AddressFrom.vue').default})
